import { InternetProviderData, SupportData } from "./components/SupportForm";
import { InternetProvider, Support } from "./types";

function internetProvidertoInternetProviderData(
  provider?: InternetProvider
): InternetProviderData | undefined {
  if (!provider) return undefined;
  const { contactEmail, contactPhone, ip } = provider;
  const internetProviderData: InternetProviderData = {
    internetProviderEmail: contactEmail,
    internetProviderPhone: contactPhone,
    internetProviderIP: ip,
  };
  return internetProviderData;
}
function internetProvidersToInternetProvidersData(
  internetProviders?: InternetProvider[]
): InternetProviderData[] | undefined {
  if (!internetProviders) return undefined;
  const internetProvidersData: InternetProviderData[] = internetProviders
    .map((provider) => internetProvidertoInternetProviderData(provider))
    .filter(
      (providerData) => providerData !== undefined
    ) as InternetProviderData[];
  return internetProvidersData;
}

function internetProviderDataToInternetProvider(
  internetProviderData?: InternetProviderData
): InternetProvider | undefined {
  if (!internetProviderData) return undefined;
  const { internetProviderEmail, internetProviderPhone, internetProviderIP } =
    internetProviderData;
  const internetProvider: InternetProvider = {
    contactEmail: internetProviderEmail ?? undefined,
    contactPhone: internetProviderPhone ?? undefined,
    ip: internetProviderIP ?? undefined,
  };
  return internetProvider;
}
function internetProvidersDataToInternetProviders(
  internetProvidersData?: InternetProviderData[]
): InternetProvider[] | undefined {
  if (!internetProvidersData) return undefined;
  const internetProviders: InternetProvider[] = internetProvidersData
    .map((internetProviderData) =>
      internetProviderDataToInternetProvider(internetProviderData)
    )
    .filter(
      (internetProvider) => internetProvider !== undefined
    ) as InternetProvider[];
  return internetProviders;
}
export function supportToSupportData(
  support?: Support
): SupportData | undefined {
  if (!support) return undefined;
  const { concessionaire, internetProviders, localDataServerIP } = support;
  const supportData: SupportData = {
    concessionaireEmail: concessionaire?.contactEmail,
    concessionairePhone: concessionaire?.contactPhone,
    localDataServerIP: localDataServerIP,
    internetProviders:
      internetProvidersToInternetProvidersData(internetProviders),
  };
  return supportData;
}
export function supportDataToSupport(
  supportData?: SupportData
): Support | undefined {
  if (!supportData) return undefined;
  const {
    concessionaireEmail,
    concessionairePhone,
    localDataServerIP,
    internetProviders,
    idLocalizacao,
    phoneNumber
  } = supportData;
  const support: Support = {
    concessionaire: {
      contactEmail: concessionaireEmail ?? undefined,
      contactPhone: concessionairePhone ?? undefined,
    },
    internetProviders: internetProvidersDataToInternetProviders(
      internetProviders ?? undefined
    ),
    localDataServerIP: localDataServerIP ?? undefined,
    idLocalizacao: idLocalizacao ?? undefined,
    phoneNumber: phoneNumber ?? undefined
  };
  return support;
}
